import * as types from '../actions/actionTypes';

const initialState = {
	entities: [],
	activeEntity: null,
	activeEntityFieldErrors: {},
	newLoadedEntityFields: [],
	isActiveEntityModified: false,
	isLoading: false,
	isLoadingEntity: false,
	isWaitingRequest: false,
	requestSuccessMessage: '',
	error: '',
	initialEntitiesRequest: false,
	expandedSections: {
		'EntityFields': true,
		'EntityAddress': true,
		'EntityCustomFields': true,
		'EntityRelatedCountries': true,
		'EntityDocumentTypes': true,
		'EntityIdentificationDocuments': true,
		'CommentsHistory': true
	}
};

export const reducer = (state, action) => {
	state = state || initialState;

	switch (action.type) {
		case types.getEntities:
			return {
				...state,
				error: '',
				isLoading: true,
			};
		case types.getEntitiesSuccess:
			return {
				...state,
				entities: action.entities,
				isLoading: false,
			};
		case types.getEntityFields:
			return {
				...state,
				error: '',
				isLoadingEntity: true,
				newLoadedEntityFields: [],
			};
		case types.getEntityFieldsSuccess:
			return {
				...state,
				activeEntity: action.entity,
				activeEntityFieldErrors: {},
				isActiveEntityModified: false,
				isLoadingEntity: false,
			};
		case types.reloadEntityFields:
			return {
				...state,
				error: '',
				requestSuccessMessage: '',
				isLoadingEntity: true,
			};
		case types.reloadEntityFieldsSuccess:
			return {
				...state,
				activeEntity: action.reloadedEntity,
				activeEntityFieldErrors: {},
				newLoadedEntityFields: action.newEntityFields,
				isActiveEntityModified: false,
				isLoadingEntity: false,
			};
		case types.setActiveEntityFieldModified:
			return {
				...state,
				isActiveEntityModified: action.isModified,
			};
		case types.setExpandedSections:
			return {
				...state,
				expandedSections: action.expandedSections
			};
		case types.setActiveEntityFieldErrors:
			return {
				...state,
				activeEntityFieldErrors: action.errors,
			};
		case types.clearActiveEntityFieldError:
			return {
				...state,
				activeEntityFieldErrors: action.errors,
			};
		case types.saveEntity:
			return {
				...state,
				error: '',
				isWaitingRequest: true,
			};
		case types.saveEntitySuccess:
			return {
				...state,
				isActiveEntityModified: false,
				isWaitingRequest: false,
			};
		case types.submitEntity:
			return {
				...state,
				error: '',
				isWaitingRequest: true,
			};
		case types.submitEntitySuccess:
			return {
				...state,
				requestSuccessMessage: action.message,
				isActiveEntityModified: false,
				isWaitingRequest: false,
			};
		case types.getUserAccounts:
			return {
				...state,
				isWaitingRequest: true,
			};
		case types.getUserAccountsSuccess:
			return {
				...state,
				userAccounts: action.userAccounts,
				isWaitingRequest: false,
			};
		case types.selfServiceApiRequestError:
			return {
				...state,
				error: action.error,
				isLoading: false,
				isLoadingEntity: false,
				isWaitingRequest: false,
			};
		case types.setEntitiesInitialRequestStatus:
			return {
				...state,
				initialEntitiesRequest: action.initialEntitiesRequest,
			};
		case types.downloadDocument:
			return {
				...state,
				isWaitingRequest: true,
			};
		case types.downloadDocumentSuccess:
			return {
				...state,
				isWaitingRequest: false,
			};
		case types.deleteDocument:
			return {
				...state,
				isWaitingRequest: true,
			};
		case types.deleteDocumentSuccess:
			return {
				...state,
				activeEntity: { ...state.activeEntity, DocumentTypes: action.DocumentTypes },
				isWaitingRequest: false,
				isLoading: false,
			};
		case types.uploadDocument:
			return {
				...state,
				isWaitingRequest: true,
			};
		case types.uploadDocumentSuccess:
			return {
				...state,
				activeEntity: { ...state.activeEntity, DocumentTypes: action.DocumentTypes },
				isWaitingRequest: false,
			};
		case types.gettingIdentificationDocumentTypes:
			return {
				...state,
				gettingIdentificationDocumentTypes: action.gettingIdentificationDocumentTypes,
			};
		case types.identificationDocumentTypesSuccess:
			return {
				...state,
				IdentificationDocumentTypes: action.IdentificationDocumentTypes,
			};
		case types.idVerificationIsEnabled:
			return {
				...state,
				idVerificationIsEnabled: action.enabled
			};
		case types.idVerificationSkipped:
			return {
				...state,
				idVerificationSkipped: action.skipped
			};
		case types.updateIdentificationDocumentField:
			var stateCopy = JSON.parse(JSON.stringify(state));
			var document = stateCopy.activeEntity.IdentificationDocuments.find(d => d.ID === action.idDocument.ID);
			document[action.fieldName] = action.value;
			return stateCopy;
		case types.addIdentificationDocument:
			var stateCopy = JSON.parse(JSON.stringify(state));
			stateCopy.activeEntity.IdentificationDocuments = [...stateCopy.activeEntity.IdentificationDocuments];
			stateCopy.activeEntity.IdentificationDocuments.push(action.newIdentificationDocument);
			return stateCopy;
		default:
			return state;
	}
};
